import React from 'react';
import { connect } from 'react-redux';
import 'animate.css/animate.min.css';
import CarrierView from './components/CarrierViewComponent';
import CarrierViewNotFast from './components/CarrierViewComponent-Not-fast-lane';

const mapStatetoProps = (state) => {
    return {
        state: state
    }
}

const setHtml = (markup) => {
    return {
        __html: markup
    }
}

const SectionTitle = (props) => {
    const { title, subTitle, image } = props.state.sectionTitleReducer;
    console.log('page shell');
    const style = {
        animationDelay: '1s'
    };

    let riskData = {
        isFraudIndicator: null,
        scoreDecile: {
            code: null,
            description: null
        }
    }, 
    messages = [], 
    quoteScores = {};
    

    if (props.state.quoteStart.underWriting) {
        riskData = {
            ...props.state.quoteStart.underWriting.underwriting.body.completeQuote.riskCheckScoreSummary
        };
        //const {code, description} = riskData.scoreDecile;
        messages = props.state.quoteStart.underWriting.underwriting.body.completeQuote.messages;
        quoteScores = props.state.quoteStart.underWriting.underwriting.body.completeQuote.quoteScores;
    }

    return (
        <div>
            <p style={style} className="iconSection animated bounce" dangerouslySetInnerHTML={setHtml(image)} />
            <div dangerouslySetInnerHTML={setHtml(title)} />
            <p dangerouslySetInnerHTML={setHtml(subTitle)} />
            {props.match.path === '/endquote'? <CarrierView
                riskData={riskData}
                messages={messages}
                quoteScores={quoteScores}
                happyPath={props.state.quoteStart.happyPath}
             />: null}
            
        </div>
    );
}

export default connect(mapStatetoProps)(SectionTitle);


// WEBPACK FOOTER //
// ./src/SectionTitle/index.js